import loadImage from './loadImage'

export default async source => {
    const image = await loadImage(source)
    const { width, height } = image
    return { width, height, image }
}
